import React from 'react';
import { useRecoilState } from 'recoil';
import { Current_User } from '../../recoil/recoil';
import PlDashboard from './plDashboard';
import GcspDashboard from './gcspDashboard';

function Dashboard(props) {
  const [currentUser, setCurrentUser] = useRecoilState(Current_User);

  return (
    <>
      {' '}
      {currentUser != null && currentUser.role == 'PL' && <PlDashboard></PlDashboard>}
      {currentUser != null && currentUser.role == 'GCSP' && <GcspDashboard></GcspDashboard>}
    </>
  );
}

export default Dashboard;
